import * as createjs from 'createjs-module';
import { Component, Injectable } from '@angular/core';
// import * as $ from 'jquery';
declare var $: any;
@Injectable()
export class AudioControllerComponent {
  public audioElement: any = null;
  public audioEnded: boolean = false;
  public audioPlaying: boolean = false;

  constructor(){
    this.createAudioTag();
    this.audioElement.src = ""
  }

  createAudioTag(): void {
    this.audioElement = document.createElement('audio');
    this.audioElement.preload = "auto";
  }
  setAudiosrc(source): void {
    $('.audioPause').removeClass("audioPause");
    this.audioElement.src = source;
  }
  playPauseAudio(event): void {
    if (event.type == 'click' || event.type == 'keydown' && (event.keyCode == 32 || event.keyCode == 13)) {

      $('.audioPause').is(':visible') ? this.pauseAudio(event) : this.playAudio(event)
      if ($('.audioPause').is(':visible')) {
        $(".audioButton").attr("aria-label", "pause audio")
      } else {
        $(".audioButton").attr("aria-label", "play audio")
      }
    }
  }
  playAudio(event): void {
    let audioName = $(event.target).attr('audioname')
    let _aname1, _aname2;
    if (audioName){
      _aname1 = audioName.split("/").pop();
      _aname2 = this.audioElement.src.split("/").pop();
    }

    if (!$('.popup').is(':visible') && _aname1 != _aname2) {
      this.setAudiosrc(audioName);
    }
    $(event.target).addClass('audioPause');
    this.audioElement.play();
    var self = this;
    this.audioElement.onended = function () {
      $('.audioPause').removeClass("audioPause");
      $(".audioButton").attr("aria-label", "play audio");
      //console.log(self.services1.getQuestionObj())
    }
  }
  pauseAudio(event): void {
    $(".audioButton").attr("aria-label", "play audio")
    $('.audioPause').removeClass("audioPause");
    this.audioElement.pause();
    if ($(event.target).attr('id') == "audioButton_2" || $(event.target).attr('id') == "audioButton_3") {
      if ($(event.target).attr("audioname").split("/").pop() != this.audioElement.src.split("/").pop()) {
        this.playAudio(event)
      }

    }
  }

}
